var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "91px",
    viewBox: "0 0 91 91",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2 0C54.6359 0 55.8194 1.09378 55.9812 2.50291L56 2.83333L56 65.1667C56 66.6197 54.9191 67.8173 53.5265 67.9809L53.2 68L30.8 68C29.2536 68 28 66.7315 28 65.1667C28 63.7136 29.0809 62.5161 30.4735 62.3524L30.8 62.3333L50.4 62.3333L50.4 5.66667L25.2538 5.66614L5.6 6.04633L5.6 36.8333C5.6 38.2864 4.51909 39.4839 3.12654 39.6476L2.8 39.6667C1.36406 39.6667 0.18058 38.5729 0.0188376 37.1638L0 36.8333L0 3.26923C0 1.83591 1.05283 0.647486 2.42434 0.461261L2.74616 0.436421L25.2 0L53.2 0Z",
    transform: "matrix(-1 0 0 -1 73 79)",
    id: "Path-2",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 0L2.8125 0C1.2592 0 0 1.2592 0 2.8125L0 28.125C0 29.6783 1.2592 30.9375 2.8125 30.9375L19.6875 30.9375C21.2408 30.9375 22.5 29.6783 22.5 28.125L22.5 2.8125C22.5 1.2592 21.2408 0 19.6875 0ZM16.8741 5.62279L16.8741 25.3103L5.6241 25.3103L5.6241 5.62279L16.8741 5.62279Z",
    transform: "matrix(0.70710677 0.70710677 -0.70710677 0.70710677 63.793068 5.2545147)",
    id: "Rectangle",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6918 0L2.81684 0C0.630703 0 -0.719615 2.38492 0.405145 4.25952L8.84264 18.322C9.93503 20.1427 12.5737 20.1427 13.666 18.322L22.1035 4.25952C23.2283 2.38492 21.878 0 19.6918 0ZM14.7262 5.6235L11.2555 11.4088L7.78211 5.6235L14.7262 5.6235Z",
    transform: "matrix(0.70710677 0.70710677 -0.70710677 0.70710677 45.89136 23.150085)",
    id: "Path-9",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 0L16.875 5.625L0 5.625L0 0L16.875 0Z",
    transform: "matrix(0.70710677 0.70710677 -0.70710677 0.70710677 57.65625 13.962563)",
    id: "Path-10",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1667 0C32.7315 0 34 1.34315 34 3C34 4.53851 32.9062 5.80652 31.4971 5.97982L31.1667 6L2.83333 6C1.26853 6 0 4.65685 0 3C0 1.46149 1.09378 0.193479 2.50291 0.0201832L2.83333 0L31.1667 0Z",
    transform: "translate(28 62)",
    id: "Path-4-Copy-2",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1667 0C32.7315 0 34 1.34315 34 3C34 4.53851 32.9062 5.80652 31.4971 5.97982L31.1667 6L2.83333 6C1.26853 6 0 4.65685 0 3C0 1.46149 1.09378 0.193479 2.50291 0.0201832L2.83333 0L31.1667 0Z",
    transform: "translate(28 50)",
    id: "Path-4-Copy-3",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L90 0L90 90L0 90L0 0Z",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedaction);
export default __webpack_public_path__ + "static/media/redaction.e8332aaf286874a4b73eda8e38110ebd.svg";
export { ForwardRef as ReactComponent };